import { useCallback } from 'react'

import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { ContactFlagRequestAction, IContactFlag } from 'clickNgo/entities/contactFlag'
import { useUpdateContactFlagsMutation } from 'clickNgo/entities/contactFlag/api/contactFlagApi'
import { FlagToReassign } from 'clickNgo/features/contact/contactReassignment'

export const useReassignFlags = () => {
  const [updateContactFlags] = useUpdateContactFlagsMutation()

  const reassignFlags = useCallback(
    async (flagsToReassign: FlagToReassign[]): Promise<void> => {
      const updatedContactFlags = flagsToReassign
        .filter((item) => !!item.contact)
        .map<IContactFlag>((item) => ({
          ...item.flag,
          contactId: item.contact!.contactId,
        }))

      await updateContactFlags({
        contactFlags: updatedContactFlags,
        action: ContactFlagRequestAction.Add,
        source: ProfilingRequestSource.ClickAndGoPortal,
      }).unwrap()
    },
    [updateContactFlags]
  )

  return { reassignFlags }
}
